"use client";

import { Trash as ReactTrash } from "./deprecated/Trash";

export const Trash = ReactTrash;
